import React from 'react'
import styled from 'styled-components'
import { Formik, Field } from 'formik'
import { string, bool, object } from 'yup'
import Text from '../../Text'
import Input from '../../Input'
import CheckBox from '../../CheckBox'

import NdsThemeProvider from '@ntuctech/devex-tangram/Theme/NdsThemeProvider'
import ButtonContained from '@ntuctech/devex-tangram/Button/ButtonContained'

const Footer = styled.div`
  display: flex;
  margin-top: 1.25rem;
`

const StyledContinueButtonContainer = styled.div`
  margin-left: auto;
  button {
    min-width: auto !important;
  }
`

const GeBizPayment = ({ onSubmit }) => {
  const paymentMethodGeBiz = {
    'title': 'Ministries and Statutory Boards only',
    'subTitle':
      'Invoice will be uploaded to GeBIZ once the order is delivered.',
    'toc':
      'By selecting GeBIZ as the mode of payment, I confirm that I am authorised to make this purchase for and on behalf of the Government Ministry and/or Statutory Board specified in the order. I agree, understand and acknowledge that NTUC Fairprice Co-operative Limited may take all necessary action, including legal action, against any unauthorized use of the FairPrice Services.',
  }
  const { toc, title, subTitle } = paymentMethodGeBiz

  const generatedValidationSchema = {
    poNumber: string()
      .required('Enter your PO number')
      .test(
        'Validate valid PO number',
        'You have entered an invalid PO number. Please check your entry.',
        function (value) {
          return value && (value[0] === 'O' || value[0] === 'o')
        }
      ),
    toc: bool().oneOf([true], 'Please accept the terms to continue'),
  }
  const initialValues = {
    toc: false,
    poNumber: '',
  }

  return (
    <Formik
      initialValues={initialValues}
      validateOnChange
      validationSchema={object().shape(generatedValidationSchema)}
      onSubmit={formValues => {
        //we don't need to send toc to the server
        const clonedFormValues = { ...formValues }
        delete clonedFormValues.toc
        onSubmit(clonedFormValues)
      }}
    >
      {({ handleSubmit, setFieldValue, touched, errors }) => (
        <form
          onSubmit={event => {
            event.preventDefault()
            handleSubmit()
          }}
        >
          <div>
            <Text as="p" weight="bold">
              {title}
            </Text>
            <Text as="p">{subTitle}</Text>
          </div>
          <div>
            <Field name="poNumber">
              {({ field }) => (
                <Input
                  data-testid="gebiz-po-number"
                  label="PO Number"
                  name={field.name}
                  type="text"
                  margin="1rem 0"
                  onChange={event => {
                    const { value } = event.target
                    setFieldValue(field.name, value)
                  }}
                  invalid={errors && touched[field.name] && errors[field.name]}
                  variant={errors[field.name] && touched[field.name] && 'error'}
                  value={field.value}
                />
              )}
            </Field>
            <Field name="toc">
              {({ field }) => (
                <CheckBox
                  data-testid="gebiz-toc"
                  inlineLabel={toc}
                  name={field.name}
                  onChange={value => {
                    setFieldValue(field.name, value)
                  }}
                  invalid={errors && touched.toc && errors.toc}
                  checked={field.value}
                  value={field.value}
                />
              )}
            </Field>
          </div>
          <Footer>
            <NdsThemeProvider>
              <StyledContinueButtonContainer>
                <ButtonContained
                  compact
                  size="l"
                  type="submit"
                  data-testid="checkout-gebiz-continue-button"
                >
                  Continue
                </ButtonContained>
              </StyledContinueButtonContainer>
            </NdsThemeProvider>
          </Footer>
        </form>
      )}
    </Formik>
  )
}

export default GeBizPayment
